// 设备接口 文件
import request from "@/utils/request";

// 获取设备所有型号
export function getAllType() {
  return request({
    url: "/base/video/recorder/v1/getSnModels",
    method: "get",
  });
}
// 设备列表
export function Equmentlist(data) {
  return request({
    url: "/base/device/v1/getVideoRecords",
    method: "post",
    data: data,
  });
}
// 设备列表 告知设备推送当前设备画面图片
export function EqumentViewImg(data) {
  return request({
    url: "/base/device/v1/startDevFrame",
    method: "post",
    data: data,
  });
}
// 录播一体机 通知设备推流
export function sendopenLive(data) {
  return request({
    url: `/base/device/v1/hero/startWebRtcBySns`,
    method: "post",
    data: data,
  });
}

//-----------------------------------------------------------------------------------

// 公告管理 后台 列表
export function selectListByUserId(data) {
  return request({
    url: "/app/zhkt/announcement/selectListByUserId",
    method: "post",
    data: data,
  });
}
// 公告管理 删除
export function deleteNoticeById(data) {
  return request({
    url: `/app/zhkt/announcement/v1/deleteByIds`,
    method: "post",
    data: data,
  });
}
// 公告管理 查询
export function getNoticeInfoById(data) {
  return request({
    url: `/app/zhkt/announcement/v1/getInfoById?id=${data}`,
    method: "get",
  });
}
// 公告管理 保存
export function NoticeSave(data) {
  return request({
    url: "/app/zhkt/announcement/v1/save",
    method: "post",
    data: data,
  });
}
// 公告管理 保存并发布
export function NoticeSaveRelease(data) {
  return request({
    url: "/app/zhkt/announcement/v1/saveIssue",
    method: "post",
    data: data,
  });
}
// 公告管理 发布
export function issue(data) {
  return request({
    url: `/app/zhkt/announcement/v1/issue?id=${data}`,
    method: "post",
  });
}
// 公告管理 取消发布
export function cancelIssue(data) {
  return request({
    url: `/app/zhkt/announcement/v1/cancelIssue?id=${data}`,
    method: "post",
  });
}
// 公告管理 置顶
export function SetTop(data){
    return request({
        url: `/app/zhkt/announcement/v1/setTop?id=${data}`,
        method: "post"
    })
}
// 公告管理 取消置顶
export function cancelSetTop(data){
    return request({
        url: `/app/zhkt/announcement/v1/cancelTop?id=${data}`,
        method: "post"
    })
}
// 公告管理 编辑
export function NoticeSet(data) {
  return request({
    url: "/app/zhkt/announcement/v1/update",
    method: "post",
    data: data,
  });
}
// 公告类型 列表
export function NoticeTypelist() {
  return request({
    url: "/app/zhkt/announcementtype/selectList",
    method: "post",
  });
}
// 公告类型 新增
export function tagsAdd(data) {
  return request({
    url: "/app/zhkt/announcementtype/v1/save",
    method: "post",
    data: data,
  });
}
// 公告类型 删除
export function tageDele(data) {
  return request({
    url: `/app/zhkt/announcementtype/v1/deleteById?typeId=${data}`,
    method: "get",
  });
}

//-----------------------------------------------------------------------------------

// 平台管理 导航设置 数据结构
export function navMenulist(data) {
  return request({
    url: "/app/zhkt/navigation/v1/list",
    method: "post",
    data: data,
  });
}
// 平台管理 导航设置 编辑
export function setMenuNav(data) {
  return request({
    url: "/app/zhkt/navigation/v1/saveBatch",
    method: "post",
    data: data,
  });
}
// 平台管理 个性化设置信息查询
export function getInfoInDividuation(data, schoolId) {
  return request({
    url: `/base/application/v1/getInfoById?id=${data}&schoolId=${schoolId}`,
    method: "get",
  });
}
// 平台管理 个性化设置保存
export function ServerInfoInDividuation(data) {
  return request({
    url: `/base/application/v1/saveOrUpdate`,
    method: "post",
    data: data,
  });
}
// 设备设置 获取设备设置回显信息
export function EqumentDataView() {
  return request({
    url: "/base/video/recorder/v1/queryDevSetup",
    method: "get",
  });
}
// 设备设置
export function EqumentSet(data) {
  return request({
    url: "/base/video/recorder/v1/updateDevSetup",
    method: "post",
    data: data,
  });
}
// 平台管理 个性化 脚链 列表
export function getAnkletList(data) {
  return request({
    url: `/app/zhkt/anklet/v1/page`,
    method: "post",
    data: data,
  });
}
// 平台管理 个性化 脚链 新增
export function ankletSave(data) {
  return request({
    url: `/app/zhkt/anklet/v1/save`,
    method: "post",
    data: data,
  });
}
// 平台管理 个性化 脚链 编辑
export function UpdateAnkletSave(data) {
  return request({
    url: `/app/zhkt/anklet/v1/update`,
    method: "post",
    data: data,
  });
}
// 平台管理 个性化 脚链 删除
export function DeleAnkletSave(data) {
  return request({
    url: `/app/zhkt/anklet/v1/deleteById?id=${data}`,
    method: "get",
  });
}
// 平台管理 个性化 脚链批量排序

export function AnkletSorts(data) {
  return request({
    url: `/app/zhkt/anklet/v1/updateBatch`,
    method: "post",
    data: data,
  });
}
//-----------------------------------------------------------------------------------

// 用户批量授权角色
export function batchAuthRoles(data) {
  return request({
    url: `/app/zhkt/role/v1/batchAuthRoles`,
    method: "post",
    data: data,
  });
}
// 用户管理 列表
export function getUserList(data) {
  return request({
    url: `/app/zhkt/role/v1/userList`,
    method: "post",
    data: data,
  });
}
// 用户管理 编辑用户角色
export function setUserData(data) {
  return request({
    url: "/app/zhkt/role/v1/authRole",
    method: "post",
    data: data,
  });
}

// 用户管理 角色列表
export function getRoleList(data) {
  return request({
    url: "/app/zhkt/role/v1/page",
    method: "post",
    data: data,
  });
}

// 用户管理 新增/修改角色
export function addRoleList(data) {
  return request({
    url: "/app/zhkt/role/v1/saveOrUpdate",
    method: "post",
    data: data,
  });
}
export function DELEROLE(data) {
  return request({
    url: `/app/zhkt/role/v1/deleteById?roleId=${data}`,
    method: "get",
  });
}
// 用户管理 获取菜单树
export function getMenuTree() {
  return request({
    url: `/app/zhkt/role/v1/getMenuTree`,
    method: "get",
  });
}
